import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Receipt as ReceiptIcon, Camera, MagnifyingGlass } from "@phosphor-icons/react";
import { api, money } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const FLAGS = [["", "All"], ["unassigned", "Unassigned"], ["duplicate", "Duplicates"], ["returned", "Returns"]];

export default function Receipts() {
  const nav = useNavigate();
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [flag, setFlag] = useState("");

  const load = () => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (flag) params.set("flag", flag);
    api.get(`/receipts?${params.toString()}`).then((r) => setList(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, [flag]);

  return (
    <div className="min-h-screen">
      <header className="px-5 pt-7 pb-3 flex items-center justify-between">
        <h1 className="font-heading text-3xl font-black text-zinc-900 tracking-tight">Receipts</h1>
        <Button data-testid="receipts-scan-btn" onClick={() => nav("/receipt/scan")} size="sm" className="h-10 gap-1.5 bg-orange-600 hover:bg-orange-700 font-bold">
          <Camera size={18} weight="fill" /> Scan
        </Button>
      </header>

      <div className="px-5 space-y-3">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative">
          <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
          <Input data-testid="receipts-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search store or receipt #" className="h-11 pl-10" />
        </form>
        <div className="flex gap-1.5 overflow-x-auto pb-1">
          {FLAGS.map(([v, l]) => (
            <button key={v} data-testid={`receipts-filter-${v || "all"}`} onClick={() => setFlag(v)}
              className={`shrink-0 h-8 px-3 rounded-full text-xs font-bold border ${flag === v ? "bg-zinc-900 text-white border-zinc-900" : "bg-white text-zinc-600 border-zinc-200"}`}>{l}</button>
          ))}
        </div>

        {list.length === 0 && (
          <div className="text-sm text-zinc-400 py-10 text-center border border-dashed border-zinc-200 rounded-xl" data-testid="receipts-empty">
            No receipts yet. Tap Scan to add one.
          </div>
        )}
        <div className="space-y-2.5 pb-4">
          {list.map((r) => (
            <button key={r.id} data-testid={`receipt-row-${r.id}`} onClick={() => nav(`/receipt/scan?id=${r.id}`)}
              className="w-full text-left bg-white border border-zinc-200 rounded-xl p-3.5 flex items-center gap-3 active:scale-[0.99] transition-transform">
              <div className="w-10 h-10 rounded-lg bg-orange-50 text-orange-600 flex items-center justify-center shrink-0"><ReceiptIcon size={22} weight="bold" /></div>
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-zinc-900 truncate">{r.store || "Unknown store"}</p>
                <p className="text-xs text-zinc-500 truncate">{r.purchase_date || "—"} · {(r.items || []).length} items{r.receipt_number ? ` · #${r.receipt_number}` : ""}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="font-heading font-black text-zinc-900">{money(r.total)}</p>
                <div className="flex gap-1 justify-end mt-0.5">
                  {r.possible_duplicate_of && <span className="text-[9px] font-bold uppercase bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded">Dup</span>}
                  {r._returned && <span className="text-[9px] font-bold uppercase bg-red-100 text-red-700 px-1.5 py-0.5 rounded">Return</span>}
                  {!r._assigned && <span className="text-[9px] font-bold uppercase bg-zinc-100 text-zinc-500 px-1.5 py-0.5 rounded">Unassigned</span>}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
